/* Game Raiders theme 5 */
(function () {
  'use strict';
  var GR = window.GR || { routes: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML.replace(/"/g, '&quot;'); };

  function toast(message) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toast.t);
    toast.t = setTimeout(function () { el.hidden = true; }, 3500);
  }

  /* Dark and light mode */
  $$('[data-theme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var next = document.documentElement.dataset.theme === 'light' ? 'dark' : 'light';
      document.documentElement.dataset.theme = next;
      try { localStorage.setItem('gr-theme', next); } catch (e) {}
    });
  });

  /* Drawer helper shared by the mobile menu, cart and collection filters */
  function drawer(panel, scrim, toggle) {
    var last = null;
    function open() {
      last = document.activeElement;
      panel.removeAttribute('inert');
      panel.classList.add('is-open');
      if (scrim) scrim.hidden = false;
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-locked');
      var focusable = $('button, a, input', panel);
      if (focusable) focusable.focus();
    }
    function close() {
      panel.setAttribute('inert', '');
      panel.classList.remove('is-open');
      if (scrim) scrim.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-locked');
      if (last && last.focus) last.focus();
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });
    return { open: open, close: close };
  }

  var navPanel = $('[data-nav-drawer]');
  if (navPanel) {
    var navToggle = $('[data-nav-open]');
    var nav = drawer(navPanel, $('.drawer-scrim[data-nav-close]'), navToggle);
    if (navToggle) navToggle.addEventListener('click', nav.open);
    $$('[data-nav-close]').forEach(function (b) { b.addEventListener('click', nav.close); });
  }

  /* Touch: first tap on a nav item with a mega menu opens it instead of leaving the page */
  $$('.has-mega > .nav-link').forEach(function (link) {
    link.addEventListener('touchend', function (e) {
      var item = link.parentElement;
      if (!item.classList.contains('is-touched')) {
        e.preventDefault();
        $$('.has-mega.is-touched').forEach(function (o) { o.classList.remove('is-touched'); });
        item.classList.add('is-touched');
        link.focus();
      }
    });
  });

  /* Cart drawer */
  var cartPanel = $('[data-cart-drawer]');
  var cartDrawer = cartPanel && drawer(cartPanel, $('.drawer-scrim[data-cart-close]'));

  function renderCart(sections) {
    if (!sections || !sections['cart-drawer'] || !cartPanel) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = $('[data-cart-inner]', doc);
    var inner = $('[data-cart-inner]', cartPanel);
    if (!fresh || !inner) return;
    inner.replaceWith(fresh);
    var count = parseInt(fresh.dataset.count, 10) || 0;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
    $$('[data-cart-total]').forEach(function (el) { el.textContent = fresh.dataset.total; });
  }

  function postCart(url, body) {
    body.sections = 'cart-drawer';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong.');
        return data;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && cartDrawer && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      cartDrawer.open();
      return;
    }
    if (e.target.closest('[data-cart-close]') && cartDrawer) {
      cartDrawer.close();
      return;
    }
    var lineBtn = e.target.closest('[data-line]');
    if (lineBtn) {
      lineBtn.disabled = true;
      postCart(GR.routes.cartChange, { line: parseInt(lineBtn.dataset.line, 10), quantity: parseInt(lineBtn.dataset.lineQty, 10) })
        .then(function (data) {
          renderCart(data.sections);
          var focus = $('[data-cart-close]', cartPanel);
          if (focus) focus.focus();
        })
        .catch(function (err) { toast(err.message); lineBtn.disabled = false; });
    }
  });

  function addToCart(form, button) {
    var data = new FormData(form);
    var payload = { id: parseInt(data.get('id'), 10), quantity: parseInt(data.get('quantity'), 10) || 1 };
    if (button) button.disabled = true;
    return postCart(GR.routes.cartAdd, payload).then(function (res) {
      renderCart(res.sections);
      if (cartDrawer) cartDrawer.open();
    }).catch(function (err) {
      toast(err.message);
    }).then(function () {
      if (button) button.disabled = false;
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-quick-add]')) {
      e.preventDefault();
      addToCart(form, $('button[type="submit"]', form));
    } else if (form.matches('[data-product-form]')) {
      e.preventDefault();
      addToCart(form, $('[data-atc]', form));
    }
  });

  /* Predictive search */
  $$('[data-search]').forEach(function (form) {
    var input = $('[data-search-input]', form);
    var box = $('[data-search-results]', form);
    var timer, controller;

    function close() { box.hidden = true; }

    function render(q, data) {
      var res = data.resources.results;
      var html = '';
      if (res.products && res.products.length) {
        html += '<h3>Products</h3>' + res.products.map(function (p) {
          return '<a class="search-hit" href="' + esc(p.url) + '">' +
            (p.image ? '<img src="' + esc(p.image) + '&width=96" alt="" width="48" height="48" loading="lazy">' : '<span></span>') +
            '<span class="search-hit-title">' + esc(p.title) + '</span>' +
            '<span class="search-hit-price">$' + esc(p.price) + '</span></a>';
        }).join('');
      }
      if (res.collections && res.collections.length) {
        html += '<h3>Categories</h3>' + res.collections.map(function (c) {
          return '<a class="search-link" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
        }).join('');
      }
      if (!html) html = '<p class="search-link">No matches for "' + esc(q) + '".</p>';
      html += '<a class="search-all" href="' + GR.routes.search + '?type=product&q=' + encodeURIComponent(q) + '">See all results</a>';
      box.innerHTML = html;
      box.hidden = false;
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = GR.routes.suggest + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.json(); })
          .then(function (d) { render(q, d); })
          .catch(function () {});
      }, 180);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    form.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.focus(); } });
  });

  /* Hero carousel */
  $$('[data-carousel]').forEach(function (root) {
    var slides = $$('[data-slide]', root);
    var dots = $$('[data-dot]', root);
    if (slides.length < 2) return;
    var i = 0, timer;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        if (k === i) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }
    function stop() { clearInterval(timer); }
    function start() {
      stop();
      if (!reduce) timer = setInterval(function () { show(i + 1); }, 6000);
    }
    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    show(0);
    start();
  });

  /* Horizontal rails */
  function initRails(scope) {
    $$('[data-rail-wrap]', scope).forEach(function (wrap) {
      var rail = $('[data-rail]', wrap);
      var prev = $('[data-rail-prev]', wrap);
      var next = $('[data-rail-next]', wrap);
      if (!rail || !prev || !next) return;
      function sync() {
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      }
      function by(dir) { rail.scrollBy({ left: dir * rail.clientWidth * 0.9, behavior: 'smooth' }); }
      prev.addEventListener('click', function () { by(-1); });
      next.addEventListener('click', function () { by(1); });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }
  initRails();

  /* Product page */
  $$('[data-product]').forEach(function (root) {
    var form = $('[data-product-form]', root);
    var dataEl = $('[data-variants]', root);
    if (!form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = $('input[name="id"]', form);
    var atc = $('[data-atc]', form);
    var atcLabel = $('[data-label]', atc);
    var priceEl = $('[data-price]', root);
    var wasEl = $('[data-was]', root);
    var stockEl = $('[data-stock]', root);
    var skuEl = $('[data-sku]', root);
    var mainImg = $('[data-main-image]', root);
    var sticky = $('[data-sticky]', root);
    var groups = $$('[data-option]', root);

    function selected() {
      return groups.map(function (g) {
        var c = $('input:checked', g);
        return c ? c.value : null;
      });
    }

    function matchVariant(opts) {
      return variants.find(function (x) { return x.options.every(function (o, n) { return o === opts[n]; }); });
    }

    function setImage(src) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      $$('[data-thumb]', root).forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.thumb === src);
      });
    }

    function refreshOptionStates(current) {
      groups.forEach(function (group, g) {
        $$('input', group).forEach(function (input) {
          var test = current.slice();
          test[g] = input.value;
          var v = matchVariant(test);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function update(isInitial) {
      var opts = selected();
      var v = matchVariant(opts);
      refreshOptionStates(opts);
      groups.forEach(function (g) {
        var out = $('[data-option-value]', g);
        var c = $('input:checked', g);
        if (out && c) out.textContent = c.value;
      });
      if (!v) {
        atc.disabled = true;
        atcLabel.textContent = 'Unavailable';
        if (stockEl) { stockEl.className = 'stock stock--out'; stockEl.textContent = 'Unavailable in this combination'; }
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = v.price;
      priceEl.classList.toggle('price-now--sale', !!v.compare);
      if (wasEl) { wasEl.textContent = v.compare || ''; wasEl.hidden = !v.compare; }
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (stockEl) {
        if (!v.available) { stockEl.className = 'stock stock--out'; stockEl.textContent = 'Sold out'; }
        else if (v.tracked && v.qty > 0 && v.qty <= 5) { stockEl.className = 'stock stock--low'; stockEl.textContent = 'Only ' + v.qty + ' left'; }
        else { stockEl.className = 'stock stock--in'; stockEl.textContent = 'In stock'; }
      }
      if (skuEl) { skuEl.textContent = v.sku ? 'SKU: ' + v.sku : ''; }
      if (v.image && !isInitial) setImage(v.image);
      if (sticky) {
        var sp = $('[data-sticky-price]', sticky), sb = $('[data-sticky-atc]', sticky);
        if (sp) sp.textContent = v.price;
        if (sb) { sb.disabled = !v.available; sb.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      }
      if (!isInitial) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    groups.forEach(function (g) { g.addEventListener('change', function () { update(false); }); });
    update(true);

    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { setImage(t.dataset.thumb); });
    });

    var qty = $('[data-qty]', form);
    if (qty) {
      $$('[data-qty-step]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10);
          qty.value = Math.max(1, n);
        });
      });
    }

    if (sticky) {
      var stickyBtn = $('[data-sticky-atc]', sticky);
      if (stickyBtn) stickyBtn.addEventListener('click', function () { atc.click(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
        }).observe(atc);
      }
    }
  });

  /* Product recommendations */
  $$('[data-recs]').forEach(function (root) {
    fetch(root.dataset.recs)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = $('[data-recs-inner]', doc);
        if (inner && $('.card', inner)) {
          root.innerHTML = inner.innerHTML;
          root.hidden = false;
          initRails(root);
        }
      })
      .catch(function () {});
  });

  /* Collection filters: auto-apply, drop empty params, keep sort */
  var filterForm = $('[data-filters]');
  if (filterForm) {
    var submitFilters = function () {
      var params = new URLSearchParams();
      new FormData(filterForm).forEach(function (val, key) { if (String(val).trim() !== '') params.append(key, val); });
      var q = params.toString();
      window.location.href = filterForm.getAttribute('action') + (q ? '?' + q : '');
    };
    filterForm.addEventListener('submit', function (e) { e.preventDefault(); submitFilters(); });
    filterForm.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') submitFilters();
    });
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', submitFilters);

    var panel = $('[data-filter-panel]');
    if (panel) {
      var fd = drawer(panel, $('.drawer-scrim[data-filter-close]'));
      $$('[data-filter-open]').forEach(function (b) { b.addEventListener('click', fd.open); });
      $$('[data-filter-close]').forEach(function (b) { b.addEventListener('click', fd.close); });
    }
  }

  /* Grid and list view */
  var viewRoot = $('[data-view-root]');
  if (viewRoot) {
    var setView = function (v) {
      viewRoot.classList.toggle('is-list', v === 'list');
      $$('[data-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.view === v ? 'true' : 'false'); });
    };
    var saved = 'grid';
    try { saved = localStorage.getItem('gr-view') || 'grid'; } catch (e) {}
    setView(saved);
    $$('[data-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        setView(b.dataset.view);
        try { localStorage.setItem('gr-view', b.dataset.view); } catch (e) {}
      });
    });
  }
})();
